// Mock data for Lloyd Law Firm website

export const firmInfo = {
  name: "Lloyd Law Firm, P.L.L.C.",
  shortName: "Lloyd Law",
  tagline: "Trust. Legacy. Peace of Mind.",
  address: "9951 Atlantic Blvd, Suite 300",
  city: "Jacksonville, Florida 32225",
  phone: "904-419-3073",
  phoneLink: "+19044193073",
  email: "info@tlloyd-law.com",
  hours: "9am - 5pm Monday - Friday",
  social: {
    linkedin: "https://www.linkedin.com/company/lloyd-law-firm-pllc/",
    facebook: "https://www.facebook.com/lloydlawfirmpllc",
    instagram: "https://www.instagram.com/_llf.pllc",
  },
  scheduleUrl: "https://tidycal.com/tamla",
  logo: "/images/logo.png",
  logoHorizontal: "/images/logo-horizontal.png",
};

export const attorney = {
  name: "Tamla N. Lloyd",
  title: "Managing Attorney",
  headshot: "/images/attorney-headshot.png",
  bio: [
    "Tamla, founder and owner of Lloyd Law Firm in Jacksonville, Florida, is a compassionate and dedicated Attorney committed to guiding individuals, families, and businesses through complex legal matters with care, creativity, professionalism, and integrity.",
    "With a focus on estate planning, she provides tailored legal solutions that align with each client's unique needs and goals while upholding the rule of law.",
    "Passionate about giving back to her community, Tamla actively engages in pro bono work, educational workshops, and volunteer initiatives aimed at expanding access to legal services. Her dedication reflects her belief in empowering others through thoughtful legal counsel and meaningful community contributions.",
    "Whether crafting a comprehensive estate plan or guiding clients through important life decisions, Tamla prioritizes clear communication, strategic solutions, and long-term client success, ensuring each individual receives the guidance they need with confidence and peace of mind.",
  ],
  mission:
    "At Lloyd Law Firm, our mission is to provide all clients with compassionate and professional legal services that bring clarity, security, and peace of mind. We are dedicated to building meaningful relationships through personalized guidance tailored to each client's unique needs and goals. Rooted in our commitment to community involvement, we strive to make a lasting, positive impact by helping and advocating for our clients with care and confidence.",
  expertise: [
    {
      title: "Estate Planning",
      text: "Our Attorney works closely with clients to develop personalized plans that protect their assets, minimize tax liabilities, and ensure their legacies are preserved. Whether drafting wills, creating powers of attorney, or guiding business succession planning, Attorney Lloyd brings clarity and peace of mind to the estate planning process.",
    },
  ],
  education: [
    "Juris Doctor, Florida Coastal School of Law",
    "Master of Business Administration, University of Phoenix",
    "Bachelor of Business Administration, University of North Florida",
    "Florida Supreme Court Certified Family Mediator",
  ],
  memberships: [
    "Florida Bar Association",
    "United States District Court for the Middle District of Florida",
    "Florida Bar Leadership Academy Class XII",
    "Jacksonville Bar Association",
  ],
};

export const navLinks = [
  { label: "HOME", href: "/" },
  {
    label: "ESTATE PLANNING",
    href: "/practice-areas",
    children: [
      { label: "Protect Your Family. Preserve Your Legacy.", href: "/practice-areas" },
      { label: "Why Estate Planning Matters", href: "/why-estate-planning" },
    ],
  },
  {
    label: "ABOUT US",
    href: null,
    children: [
      { label: "Our Firm", href: "/about/our-firm" },
      { label: "Meet the Attorney", href: "/about/meet-the-attorney" },
    ],
  },
  { label: "REVIEWS", href: "/reviews" },
  { label: "FAQ", href: "/faq" },
  { label: "SCHEDULE", href: "/schedule" },
  { label: "CONTACT", href: "/contact" },
  { label: "BLOG", href: "/blog" },
];

export const whyEstatePlanning = {
  intro:
    "Estate planning is not only for the wealthy. Without proper planning, families may face unnecessary court involvement, delays, expenses, and uncertainty during already difficult times.",
  benefitsHeading: "A thoughtfully prepared estate plan can help:",
  benefits: [
    "Protect your loved ones",
    "Avoid or minimize probate",
    "Plan for incapacity",
    "Ensure your wishes are honored",
    "Provide clarity and peace of mind for your family",
  ],
  approachHeading: "A Personalized Approach",
  approachIntro:
    "At Lloyd Law Firm, we believe estate planning should never feel overwhelming or impersonal. We take the time to understand your goals, explain your options in clear language, and create a plan tailored to your unique needs and circumstances.",
  approachListHeading: "Our firm is proud to provide:",
  approach: [
    "Compassionate and approachable service",
    "Personalized legal guidance",
    "Clear communication without unnecessary legal jargon",
    "Estate planning solutions tailored to Florida law",
  ],
  whoHeading: "Who We Help",
  whoIntro: "Our estate planning services are ideal for:",
  who: [
    "Individuals and families",
    "Parents of minor children",
    "Homeowners",
    "Retirees",
    "Blended families",
    "Business owners",
    "Individuals caring for aging parents",
  ],
  closing:
    "Whether you need a simple will or a more comprehensive estate plan, we are here to help you prepare for the future with confidence.",
};

export const mediationContent = {
  intro:
    "At Lloyd Law Firm, P.L.L.C., we believe that disputes don't always need to end in court. Mediation offers a thoughtful, efficient, and cost-effective alternative for resolving conflicts while preserving relationships and fostering understanding. Our experienced mediator is here to help you find common ground and reach agreements that work for everyone involved.",
  whatHeading: "What Is Mediation?",
  whatText:
    "Mediation is a voluntary process where a neutral third-party mediator facilitates discussions between disputing parties to help them resolve their issues amicably. Unlike litigation, the mediator does not impose a decision but works with the parties to craft their own agreement.",
  whenHeading: "Mediation is commonly used in:",
  whenItems: [
    {
      title: "Family Law",
      text: "Divorce, child custody, parenting plans, and property division.",
    },
    {
      title: "Business Disputes",
      text: "Contract disagreements, partnership issues, and workplace conflicts.",
    },
    {
      title: "Civil Matters",
      text: "Neighbor disputes, landlord-tenant issues, and other civil conflicts.",
    },
  ],
  benefitsHeading: "Benefits of Mediation",
  benefits: [
    {
      title: "Cost-Effective",
      text: "Avoid costly litigation fees and reduce expenses.",
    },
    {
      title: "Timely Resolutions",
      text: "Reach agreements faster than traditional court proceedings.",
    },
    {
      title: "Confidentiality",
      text: "Discussions and outcomes remain private and protected.",
    },
    {
      title: "Preservation of Relationships",
      text: "Maintain amicable relationships by fostering open communication and understanding.",
    },
    {
      title: "Control Over Outcomes",
      text: "Parties maintain decision-making power rather than having outcomes imposed by a judge.",
    },
  ],
  whyHeading: "Why Choose Lloyd Law Firm, P.L.L.C.?",
  why: [
    {
      title: "Experienced Mediator",
      text: "Our mediator is a trained professional with expertise in legal and interpersonal conflict resolution.",
    },
    {
      title: "Customized Approach",
      text: "We tailor the mediation process to fit the unique needs of your situation.",
    },
    {
      title: "Impartial Guidance",
      text: "We ensure all parties are heard and work thoughtfully toward a fair resolution.",
    },
    {
      title: "Focus on Solutions",
      text: "Our goal is to help you move forward with agreements that benefit all parties.",
    },
  ],
  rightHeading: "Is Mediation Right for You?",
  rightText:
    "Mediation is a flexible and effective option for resolving disputes when both parties are willing to communicate openly. Whether you're facing a family, business, or civil matter, our team is here to help you navigate the process with skill and empathy.",
  scheduleHeading: "Schedule Your Mediation Session",
  scheduleText:
    "Let Lloyd Law Firm help you resolve your dispute with dignity and efficiency. Contact us today to learn more about our mediation services and how we can assist you in reaching a successful resolution.",
};

export const privacyPolicy = {
  lastUpdated: "May 25, 2025",
  intro:
    "Lloyd Law Firm, P.L.L.C. (\"Lloyd Law Firm,\" \"we,\" \"us,\" or \"our\") respects your privacy and is committed to protecting the personal information you share with us. This Privacy Policy describes the types of information we may collect through our website at tlloydlaw.com (the \"Site\") and any related services, how we use that information, who we may share it with, and the choices you have regarding our use of your information.",
  topics: [
    "Information We Collect",
    "How We Use Your Information",
    "How We Share Your Information",
    "Cookies and Online Tracking",
    "Your Choices",
    "Information Security",
    "Third-Party Links",
    "Children's Privacy",
    "Changes to This Privacy Policy",
    "Contact Us",
  ],
  sections: [
    {
      title: "Information We Collect",
      blocks: [
        {
          subtitle: "Information You Provide",
          text: "We collect information you voluntarily provide to us when you contact the firm, request a consultation, send an email, complete a form on our Site, or otherwise communicate with us. This may include your name, email address, phone number, mailing address, and any details you share about your legal matter.",
        },
        {
          subtitle: "Information Collected Automatically",
          text: "When you visit our Site, we and our service providers may automatically collect certain technical information, such as your IP address, browser type, device information, pages visited, time spent on each page, referring website, and approximate location. This information helps us understand how visitors use the Site and improve their experience.",
        },
        {
          subtitle: "Information from Third Parties",
          text: "We may receive information about you from public records, referral sources, or other third parties involved in your legal matter, but only as appropriate to the services we provide.",
        },
      ],
    },
    {
      title: "How We Use Your Information",
      text: "We use the information we collect to:",
      list: [
        "Respond to your inquiries and schedule consultations",
        "Provide and manage legal services to our clients",
        "Communicate with you about your case or our services",
        "Operate, maintain, and improve our Site",
        "Comply with applicable laws and our professional obligations",
        "Detect, prevent, or address fraud, abuse, or security issues",
      ],
    },
    {
      title: "How We Share Your Information",
      text: "We do not sell your personal information. We may share it only in limited circumstances, including:",
      list: [
        "With trusted service providers who help us operate the Site or our practice (such as IT, hosting, email, or scheduling providers), under appropriate confidentiality obligations",
        "With co-counsel, opposing counsel, courts, mediators, or other parties when reasonably necessary to represent you or carry out the services you have requested",
        "When required by law, subpoena, court order, or other legal process",
        "To protect the rights, property, or safety of Lloyd Law Firm, our clients, or others",
        "With your consent or at your direction",
      ],
    },
    {
      title: "Cookies and Online Tracking",
      text: "Our Site may use cookies and similar technologies to remember your preferences, analyze Site usage, and improve performance. You can typically control cookies through your browser settings. Disabling cookies may affect the functionality of certain features of the Site.",
    },
    {
      title: "Your Choices",
      text: "You may:",
      list: [
        "Choose not to provide certain information, though this may limit our ability to respond to you",
        "Unsubscribe from any marketing emails by following the instructions in the email",
        "Contact us to request access to, correction of, or deletion of personal information we hold about you, subject to our legal and ethical obligations as attorneys",
      ],
    },
    {
      title: "Information Security",
      text: "We use reasonable administrative, technical, and physical safeguards to help protect personal information from unauthorized access, disclosure, alteration, or destruction. However, no method of transmission over the Internet or electronic storage is completely secure, and we cannot guarantee absolute security. Do not transmit sensitive or confidential information to us through this Site.",
    },
    {
      title: "Third-Party Links",
      text: "Our Site may contain links to third-party websites for your convenience. We are not responsible for the privacy practices or content of those sites. We encourage you to review the privacy policy of any website you visit.",
    },
    {
      title: "Children's Privacy",
      text: "Our Site is not directed to children under the age of 18, and we do not knowingly collect personal information from children. If you believe a child has provided us with personal information, please contact us so we can take appropriate action.",
    },
    {
      title: "Changes to This Privacy Policy",
      text: "We may update this Privacy Policy from time to time to reflect changes in our practices or applicable law. When we do, we will revise the \"Last Updated\" date below. Your continued use of the Site after any changes constitutes your acceptance of the updated Privacy Policy.",
    },
    {
      title: "Contact Us",
      text: "If you have questions or concerns about this Privacy Policy or how we handle your personal information, please contact us at:",
      contact: true,
    },
  ],
};

export const legalDisclaimer = {
  intro:
    "The information provided on this website is for general informational purposes only and does not constitute legal advice. Viewing or interacting with this website does not create an attorney-client relationship between you and Lloyd Law Firm.",
  intro2:
    "While we strive to provide accurate and up-to-date information, laws and regulations frequently change, and the information on this website may not reflect the most current legal developments. You should not act or rely on any information from this website without speaking directly to the attorney regarding your specific situation.",
  sections: [
    {
      title: "Attorney-Client Relationship",
      text: "Contacting us through this website, email, or other forms of communication does not establish an attorney-client relationship. Confidential or time-sensitive information should not be sent through this website.",
    },
    {
      title: "No Guarantee of Results",
      text: "Past outcomes or results described on this website are not guarantees of future success. Each legal matter is unique, and outcomes depend on a variety of factors.",
    },
    {
      title: "Third-Party Links",
      text: "This website may contain links to third-party websites. These links are provided for convenience and informational purposes only. Lloyd Law Firm is not responsible for the content, accuracy, or practices of linked websites.",
    },
    {
      title: "Jurisdiction",
      text: "The attorney at Lloyd Law Firm is licensed to practice law in the State of Florida. We do not seek to represent anyone in jurisdictions where this website fails to comply with applicable laws and ethical rules.",
    },
    {
      title: "Image Disclaimer",
      text: "The photos on this website are for illustrative purposes only and do not depict employees, clients, or affiliates of Lloyd Law Firm.",
    },
    {
      title: "Copyright Notice",
      text: "All content, including text, images, logos, and other materials on this website, is the property of Lloyd Law Firm unless otherwise stated. Unauthorized use or reproduction is strictly prohibited.",
    },
  ],
};

export const practiceAreas = [
  {
    id: "estate-planning",
    title: "Estate Planning",
    icon: "Landmark",
    question:
      "Are you in need of a will, durable power of attorney, advance directives or a lady bird deed?",
    cta: "Estate Planning",
  },
  {
    id: "contact",
    title: "Contact Us",
    icon: "Contact",
    question: "Contact us about your situation.",
    cta: "Contact Us",
  },
];

export const estatePlanningServices = [
  {
    title: "Last Will and Testament",
    text: "A Last Will and Testament allows you to specify how your assets should be distributed, nominate guardians for minor children, and ensure your wishes are clearly documented.",
  },
  {
    title: "Durable Power of Attorney",
    text: "A Durable Power of Attorney allows you to appoint someone you trust to handle financial and legal matters if you become unable to do so yourself.",
  },
  {
    title: "Designation of Health Care Surrogate",
    text: "A Designation of Health Care Surrogate allows you to appoint someone you trust to make medical decisions on your behalf if you are unable to do so yourself.",
  },
  {
    title: "Living Will",
    text: "A Living Will outlines your wishes regarding life-prolonging procedures and end-of-life medical care in situations where you are unable to communicate your decisions.",
  },
  {
    title: "Lady Bird Deed",
    text: "Enhanced Life Estate Deeds, commonly known as Lady Bird Deeds, can help Florida homeowners transfer real property outside of probate while retaining control during their lifetime.",
  },
];

export const faqs = [
  {
    q: "Do I need an estate plan if I already have beneficiaries listed on my accounts?",
    a: "Yes. Beneficiary designations are only one part of a comprehensive estate plan. A properly prepared estate plan can address incapacity planning, guardianship for minor children, healthcare decisions, and assets that may not transfer automatically.",
  },
  {
    q: "How often should I update my estate plan?",
    a: "It is recommended to review your estate plan after major life events such as marriage, divorce, birth of a child, relocation, significant financial changes, or the death of a loved one.",
  },
  {
    q: "What happens if I die without a will in Florida?",
    a: "If a person dies without a valid will, Florida intestacy laws determine how assets are distributed, which may not reflect the person's wishes.",
  },
  {
    q: "Why is estate planning important, and what are its key benefits?",
    a: "Estate planning ensures that your assets are distributed according to your wishes, reduces potential tax burdens, and protects your loved ones from unnecessary legal complications. It also allows you to establish guardianship for minor children, designate beneficiaries, and create living wills or trusts to safeguard your legacy.",
  },
  {
    q: "What does the consultation process look like?",
    a: "We begin with an initial consultation to understand your goals, answer your questions, and outline a personalized plan. From there, we draft documents, review them with you, and finalize everything to your satisfaction. Our process is transparent, attentive, and tailored to your needs.",
  },
];

export const starRatings = [
  {
    id: 101,
    name: "Angelica S.",
    date: "October 26, 2020",
    stars: 5,
  },
];

export const testimonials = [
  {
    id: 1,
    highlight: "Great Experience!",
    text: "Efficient, clear and to the point, great experience.",
    name: "Larissa G.",
    date: "August 7, 2025",
  },
  {
    id: 2,
    highlight: "Excellent Service!",
    text: "Fast, efficient service working with a professional.",
    name: "Allen H.",
    date: "August 23, 2024",
  },
  {
    id: 3,
    highlight: "Easy to Work With!",
    text: "Ease in which we worked together, timely responses.",
    name: "Erin B.",
    date: "August 10, 2023",
  },
  {
    id: 4,
    highlight: "Truly Listened!",
    text: "She understood every bit and piece I was telling and asking her.",
    name: "Eugene S.",
    date: "March 7, 2023",
  },
  {
    id: 5,
    highlight: "Amazing!",
    text: "Very friendly, professional and expert advice. She was amazing. Answered all questions with accuracy.",
    name: "Quanesha L. S.",
    date: "March 21, 2022",
  },
];

export const heroImage = "/images/attorney-hero.png";

export const skylineImage =
  "https://images.unsplash.com/photo-1683552424939-dfc29064d449?w=1920&auto=format&fit=crop&q=70";

export const welcomeCopy =
  "We pride ourselves on providing excellent service and legal representation. Our goal is to serve our clients with professionalism, compassion, and competence. If you need assistance with estate planning, you can trust the Lloyd Law Firm to guide you with care.";

export const blogPosts = [
  {
    id: 1,
    slug: "5-reasons-every-florida-family-needs-an-estate-plan",
    title: "5 Reasons Every Florida Family Needs an Estate Plan",
    excerpt:
      "Whether you have substantial assets or you're just starting out, an estate plan is one of the most important steps you can take to protect your loved ones.",
    date: "May 12, 2025",
    category: "Estate Planning",
    image:
      "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=1200&auto=format&fit=crop&q=70",
    intro:
      "Many Floridians put off estate planning, believing it is only for the wealthy or for people much later in life. The reality is that an estate plan benefits nearly every adult, regardless of income or family size. Here are five practical reasons every Florida family should put a plan in place.",
    sections: [
      {
        heading: "1. You Choose How Your Assets Are Distributed",
        body: [
          "Without an estate plan, Florida's intestacy laws decide who inherits your property. These default rules apply a one-size-fits-all formula that may not reflect your wishes — especially in blended families, second marriages, or close relationships outside of legal family.",
          "A simple will or trust lets you direct exactly who receives what, on your terms.",
        ],
      },
      {
        heading: "2. You Can Name Guardians for Minor Children",
        body: [
          "If you have minor children, a properly executed will is the only document where you can nominate the person you want to raise them if something happens to you. Without that nomination, a Florida court will choose — often based on limited information about your family.",
          "Naming a guardian in advance gives you peace of mind that your children will be cared for by someone you trust.",
        ],
      },
      {
        heading: "3. You Can Avoid or Minimize Probate",
        body: [
          "Probate is the court-supervised process of administering an estate. In Florida, it can take months to over a year, involves filing fees and attorney costs, and is a matter of public record.",
          "Tools such as a Lady Bird Deed, beneficiary designations, and properly funded trusts can transfer property outside of probate, saving your family time, money, and stress.",
        ],
      },
      {
        heading: "4. You Can Plan for Incapacity, Not Just Death",
        body: [
          "An estate plan is not only about what happens after you pass away. A Durable Power of Attorney, a Designation of Health Care Surrogate, and a Living Will allow trusted individuals to make financial and medical decisions if you become unable to do so.",
          "Without these documents, your family may need to seek a court-appointed guardian — a process that is costly, slow, and emotionally taxing during an already difficult time.",
        ],
      },
      {
        heading: "5. You Can Reduce Family Conflict",
        body: [
          "Few things create more tension among family members than uncertainty after a loved one passes. Clear, written instructions reduce the likelihood of disputes by leaving little room for guesswork.",
          "A thoughtful estate plan tells your family exactly what you wanted — and allows them to grieve without having to fight.",
        ],
      },
    ],
    closing:
      "At Lloyd Law Firm, we help Florida individuals and families build estate plans that fit their lives. Whether you are creating your first plan or updating documents you put in place years ago, we are here to guide you with care and clarity.",
  },
  {
    id: 2,
    slug: "understanding-lady-bird-deeds-in-florida",
    title: "Understanding Lady Bird Deeds in Florida",
    excerpt:
      "Officially known as an Enhanced Life Estate Deed, a Lady Bird Deed can be a simple, affordable way to pass Florida real estate outside of probate.",
    date: "April 28, 2025",
    category: "Estate Planning",
    image:
      "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=1200&auto=format&fit=crop&q=70",
    intro:
      "Few estate planning tools are as uniquely Florida as the Lady Bird Deed. Officially known as an Enhanced Life Estate Deed, it can be a simple, affordable way to pass real estate to your loved ones outside of probate while keeping full control during your lifetime.",
    sections: [
      {
        heading: "What Is a Lady Bird Deed?",
        body: [
          "A Lady Bird Deed is a special type of deed that lets you keep complete ownership and control of your home or other Florida real estate during your lifetime, while naming one or more beneficiaries (called \"remainder beneficiaries\") who automatically receive the property when you pass away.",
          "Unlike a traditional life estate deed, you retain the right to sell, mortgage, lease, or revoke the deed at any time — without needing the beneficiaries' permission.",
        ],
      },
      {
        heading: "How Does It Work?",
        body: [
          "While you are alive, nothing about your ownership changes. You can live in the property, rent it out, refinance it, or sell it. The named beneficiaries have no legal interest until your death.",
          "When you pass away, the property automatically transfers to the named beneficiaries — no probate required. The transfer is typically documented by recording a certified copy of the death certificate along with an affidavit in the public records.",
        ],
      },
      {
        heading: "Key Benefits",
        body: [
          "• Avoids probate for your Florida homestead or other real estate.",
          "• You retain full ownership and control during your lifetime.",
          "• Can help avoid gift tax concerns associated with lifetime transfers.",
          "• Generally preserves Florida homestead protections and exemptions.",
          "• Beneficiaries typically receive a stepped-up tax basis at death, which may reduce future capital gains taxes.",
        ],
      },
      {
        heading: "Important Considerations",
        body: [
          "A Lady Bird Deed is a powerful planning tool, but it is not right for every situation. It does not address other assets such as bank accounts, investments, retirement accounts, or personal property. It also is not a substitute for a comprehensive estate plan that addresses incapacity planning, healthcare directives, powers of attorney, and other important considerations.",
          "In addition, once beneficiaries inherit the property, their individual circumstances may affect the property. Issues such as creditor claims, divorce, lawsuits, or bankruptcy can create future complications. Careful planning is essential to ensure your goals are fully protected.",
        ],
      },
    ],
    closing:
      "If you own real estate in Florida and want to simplify the transfer process for your loved ones, a Lady Bird Deed may be a valuable addition to your estate plan. At Lloyd Law Firm, we will review your goals and help determine whether a Lady Bird Deed or another estate planning strategy is the best fit for your unique circumstances.",
  },
  {
    id: 3,
    slug: "do-i-really-need-a-will-in-florida",
    title: "Do I Really Need a Will in Florida?",
    excerpt:
      "It is one of the most common questions clients ask. The short answer is: almost certainly, yes — and here's why.",
    date: "March 18, 2025",
    category: "Estate Planning",
    image: "/images/blog-family-consultation.png",
    intro:
      "Many Floridians believe a will is only necessary if they have a large estate, a complicated family, or significant assets. In truth, a will is one of the most basic — and most important — documents nearly every adult should have. Here is what happens with and without one in Florida.",
    sections: [
      {
        heading: "What Happens If You Die Without a Will?",
        body: [
          "If you pass away without a valid will, Florida's intestacy laws determine who inherits your property. These default rules follow a strict order based on your family relationships, not your personal wishes.",
          "For example, if you are married with children from a previous relationship, your spouse and children may have to share your estate in proportions you may not have intended. Unmarried partners, close friends, stepchildren, and charities receive nothing under intestacy — no matter how important they were to you.",
        ],
      },
      {
        heading: "Why a Will Matters — Even If You Don't Think You're \"Wealthy\"",
        body: [
          "A will is not just about money. It allows you to:",
          "• Name a personal representative (executor) you trust to handle your estate.",
          "• Nominate guardians for any minor children.",
          "• Leave specific items — heirlooms, jewelry, vehicles — to specific people.",
          "• Make charitable gifts that reflect your values.",
          "• Reduce confusion, conflict, and delay among the people you leave behind.",
        ],
      },
      {
        heading: "Common Misconceptions",
        body: [
          "\"My spouse will automatically get everything.\" Not always. Florida law splits assets between a surviving spouse and children in many situations, particularly in blended families.",
          "\"Joint accounts and beneficiary designations handle everything.\" These can transfer specific assets, but they don't cover personal items, guardianship of children, or anything left out by mistake. A will catches what beneficiary designations miss.",
          "\"I'm too young to need a will.\" Estate planning is for any adult — especially parents of minor children and homeowners. Life is unpredictable; planning early gives you control.",
        ],
      },
      {
        heading: "What Makes a Will Valid in Florida?",
        body: [
          "Florida has specific legal requirements. To be valid, your will generally must be:",
          "• In writing.",
          "• Signed by you (the testator) at the end of the document.",
          "• Witnessed by at least two competent witnesses, who sign in your presence and in the presence of each other.",
          "Handwritten (holographic) wills are not valid in Florida unless they meet these formal witnessing requirements. Many do-it-yourself wills fail at this step.",
        ],
      },
      {
        heading: "Is a Will Enough?",
        body: [
          "A will is a great foundation, but a complete estate plan often also includes a Durable Power of Attorney, Designation of Health Care Surrogate, Living Will, and — depending on your goals — a trust or Lady Bird Deed. The right combination depends on your family, assets, and wishes.",
        ],
      },
    ],
    closing:
      "If you have been putting off creating a will, you are not alone — but you also do not have to do it on your own. At Lloyd Law Firm, we walk you through the process step by step and create a plan that fits your life. The peace of mind is worth it.",
  },
];
